<template>
  <!-- INFO: Per isCompactView in Vuex, this container is only added to the DOM on medium breakpoints and down -->
  <!-- **
  * TODO: In Phase 2 when Foundation is removed, change the v-show on this parent div to v-if
  * We only want either NavLargeContainer OR NavOverlayCompactLayout to appear in the DOM at a time 
  ** -->
  <transition name="fade" @before-enter="setupOverlay" @after-leave="unsetOverlay">
    <div
      v-show="isShown"
      qaid="nav-overlay-compact"
      class="nav-overlay-compact bg-gray-100"
      :style="fullScreenMinusHeaderHeight"
    >
      <nav>
        <template v-if="!activeLink">
          <slot name="nav" />
          <slot name="utility-bar-compact" />
        </template>
        <template v-else>
          <div class="relative py-4 mx-2">
            <svg
              class="nav-overlay-compact__back-icon flex-none cursor-pointer"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              @click="goBack"
            >
              <path d="M17.67 3.87001L15.9 2.10001L6 12L15.9 21.9L17.67 20.13L9.54 12L17.67 3.87001Z" fill="white" />
            </svg>
            <div
              class="font-bold text-lg text-center text-white"
              v-html="activeTabText ? activeTabText : activeLinkText"
            />
          </div>
          <nav-lists-layout v-if="activeTab" qaid="nav-lists-compact-layout" />
          <nav-tabs-layout v-else qaid="nav-tabs-compact-layout" />
        </template>
      </nav>
    </div>
  </transition>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import NavTabsLayout from '@/navigation/layouts/NavTabsLayout.vue';
import NavListsLayout from '@/navigation/layouts/NavListsLayout.vue';

export default {
  name: 'NavOverlayCompactLayout',
  components: {
    NavTabsLayout,
    NavListsLayout,
  },
  data() {
    return {
      fullScreenMinusHeaderHeight: '',
    };
  },
  computed: {
    ...mapState('global', ['isCompactView']),
    ...mapState('navigation', ['activeLink', 'activeTab', 'currentOverlay', 'mobileMenuOpen']),
    activeLinkText() {
      return this.currentOverlay.parentLinkText;
    },
    activeTabText() {
      return this.currentOverlay?.tabs.find((tab) => tab.uid === this.activeTab)?.text;
    },
    isShown() {
      return this.isCompactView && this.mobileMenuOpen;
    },
  },
  destroyed() {
    if (this.isShown) {
      this.unsetOverlay();
    }
  },
  methods: {
    ...mapActions('navigation', ['unsetNav']),
    ...mapMutations('navigation', ['setActiveLink', 'setActiveTab']),
    disableBodyScrolling() {
      document.body.style.overflow = 'hidden';
    },
    enableBodyScrolling() {
      document.body.style.overflow = 'auto';
    },
    goBack() {
      if (this.activeTab) {
        this.setActiveTab(null);
        // If there is only 1 tab, goBack means go all the way back to the choose-a-link screen
        if (this.currentOverlay.tabs.length === 1) {
          this.setActiveLink(null);
        }
      } else {
        this.setActiveLink(null);
      }
    },
    setupOverlay() {
      this.disableBodyScrolling();
      const header = document.body.querySelector('[qaid="nav-app"]');
      this.fullScreenMinusHeaderHeight = `height: calc(100vh - ${header.offsetHeight}px);`;
    },
    unsetOverlay() {
      this.enableBodyScrolling();
      this.unsetNav();
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-overlay-compact {
  z-index: 16000009;
  position: absolute;
  width: 100%;
  overflow: auto;

  &.fade-enter-active,
  &.fade-leave-active {
    transition: opacity 0.5s, transform 0.5s;
  }
  &.fade-enter,
  &.fade-leave-to {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }

  &__back-icon {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
}
</style>
